import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getViewHistoryAction } from "../../../redux/actions/ProviderProfileDetailAction";

export const HistoryDetailsPopup = ({ rowTicketId, setRowTicketId }) => {
  const dispatch = useDispatch();

  const getViewHistory = useSelector(
    (state) => state?.providerPortalDetailReducer?.getViewHistory
  );

  useEffect(() => {
    dispatch(
      getViewHistoryAction(rowTicketId?.requestID, rowTicketId?.sessionID)
    );
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between border-bottom modalHeader">
        <h4 className="font-bold text-black">History Log</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => setRowTicketId(null)}
        ></button>
      </div>
      <div className="modal-body">
        <div className="table-responsive __custom__properties">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Sr No.</th>
                <th scope="col">Action</th>
                <th scope="col">Submitted On</th>
                <th scope="col">Submitted By</th>
                <th scope="col">Updated By</th>
                <th scope="col">Date & Time</th>
                <th scope="col">Remark</th>
              </tr>
            </thead>
            <tbody>
              {getViewHistory?.ticketHistories?.length ? (
                getViewHistory?.ticketHistories?.map((ele, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        <span
                          className={`status-style ${
                            ele?.action === "Approved"
                              ? "approved"
                              : ele?.action === "Rejected"
                              ? "rejected"
                              : "pending"
                          }`}
                        >
                          {ele?.action}
                        </span>
                      </td>
                      <td>
                        <span>{ele?.submittedOn}</span>
                      </td>
                      <td>{ele?.submittedBy}</td>
                      <td>{ele?.updatedBy}</td>
                      <td>{ele?.lastUpdatedDateTime}</td>
                      <td>{ele?.remarks}</td>
                    </tr>
                  );
                })
              ) : (
                <h2
                  style={{
                    marginTop: "20px",
                    color: "red",
                    textAlign: "center",
                  }}
                >
                  No data found
                </h2>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
